import { useEffect } from 'react';
import { Reveal } from '@/components/Reveal';

export default function AvisoPrivacidad() {
  useEffect(() => {
    document.title = 'Aviso de Privacidad | Link Consultores de Mercadeo';
  }, []);

  return (
    <div className="bg-white" data-testid="aviso-privacidad-page">
      {/* Header banner */}
      <section className="relative bg-[#0F0F0F] text-white overflow-hidden">
        <div
          className="pointer-events-none absolute -top-32 -left-32 w-96 h-96 rounded-full opacity-25 blur-3xl"
          style={{ background: 'radial-gradient(circle, rgba(255,107,0,0.45), transparent 70%)' }}
        />
        <div className="container-link py-14 sm:py-16 lg:py-20 relative">
          <Reveal>
            <p className="uppercase text-xs sm:text-sm tracking-[0.14em] text-[#ED6B24] font-semibold mb-3">
              Legal · Última actualización: Agosto 2026
            </p>
            <h1
              className="text-3xl sm:text-4xl lg:text-5xl font-black leading-tight"
              style={{ fontFamily: 'Gotham, sans-serif' }}
            >
              Política de Privacidad y<br />
              Protección de Datos Personales
            </h1>
          </Reveal>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 sm:py-14 lg:py-16">
        <div className="container-link max-w-4xl">
          <Reveal>
            <div className="text-[#58677A] leading-relaxed text-[15px] sm:text-base [&_a]:text-[#ED6B24] [&_a:hover]:underline">
              <p className="mb-4">
                En <strong>LINK</strong> valoramos la confianza de nuestros clientes, proveedores, aliados, colaboradores y usuarios. Por ello, nos comprometemos a proteger la privacidad y los datos personales proporcionados a través de nuestro sitio web, formularios, canales digitales y demás medios de contacto.
              </p>
              <p className="mb-8">
                La presente Política de Privacidad explica cómo recopilamos, utilizamos, almacenamos y protegemos la información personal de nuestros usuarios.
              </p>

              <Section title="1. Responsable del tratamiento de datos">
                <p className="mb-2">El responsable del tratamiento de los datos personales es:</p>
                <ul className="space-y-0.5">
                  <li><strong>LINK</strong></li>
                  <li><strong>RUC:</strong> 1793146813001</li>
                  <li><strong>Domicilio:</strong> Cumbayá, Quito, Ecuador</li>
                  <li><strong>Correo electrónico:</strong> <a href="mailto:estamos@pasameunlink.com">estamos@pasameunlink.com</a></li>
                  <li><strong>Teléfono:</strong> 099 771 7151</li>
                </ul>
              </Section>

              <Section title="2. Datos personales que podemos recopilar">
                <p className="mb-2">Dependiendo de la interacción del usuario con nuestros canales, podemos recopilar información como:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Nombres y apellidos.</li>
                  <li>Número de teléfono.</li>
                  <li>Dirección de correo electrónico.</li>
                  <li>Empresa u organización a la que pertenece.</li>
                  <li>Cargo o información profesional.</li>
                  <li>Información proporcionada mediante formularios de contacto o solicitudes de cotización.</li>
                  <li>Información relacionada con servicios, eventos, activaciones o proyectos solicitados.</li>
                  <li>Información técnica relacionada con la navegación en nuestro sitio web, como dirección IP, tipo de dispositivo, navegador y cookies, cuando corresponda.</li>
                </ul>
                <p className="mt-3">LINK únicamente recopilará los datos necesarios para las finalidades descritas en esta política.</p>
              </Section>

              <Section title="3. Finalidad del tratamiento">
                <p className="mb-2">Los datos personales recopilados podrán ser utilizados para:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Atender consultas, solicitudes de información y requerimientos.</li>
                  <li>Preparar y enviar propuestas comerciales o cotizaciones solicitadas.</li>
                  <li>Gestionar relaciones comerciales con clientes, proveedores y aliados.</li>
                  <li>Coordinar servicios relacionados con eventos, activaciones BTL, branding, marketing digital, comunicación y demás servicios ofrecidos por LINK.</li>
                  <li>Mantener comunicación relacionada con proyectos o servicios contratados.</li>
                  <li>Enviar información comercial, novedades, contenidos o comunicaciones promocionales cuando exista autorización del titular.</li>
                  <li>Analizar el funcionamiento y uso de nuestro sitio web para mejorar la experiencia del usuario.</li>
                  <li>Cumplir obligaciones legales, contractuales y administrativas aplicables.</li>
                </ul>
              </Section>

              <Section title="4. Base para el tratamiento de los datos">
                <p className="mb-3">El tratamiento de los datos personales se realizará conforme a la legislación aplicable en Ecuador y podrá fundamentarse, según corresponda, en el consentimiento del titular, la ejecución de una relación contractual, el cumplimiento de obligaciones legales u otras bases legitimadoras permitidas por la normativa vigente.</p>
                <p>Cuando sea necesario obtener consentimiento, el usuario podrá retirarlo posteriormente mediante los canales establecidos en esta política.</p>
              </Section>

              <Section title="5. Protección y almacenamiento de la información">
                <p className="mb-3">LINK implementará medidas administrativas, técnicas y organizativas razonables para proteger los datos personales frente a accesos no autorizados, pérdida, alteración, divulgación o uso indebido.</p>
                <p>Los datos serán conservados únicamente durante el tiempo necesario para cumplir las finalidades para las cuales fueron recopilados o durante los períodos exigidos por las disposiciones legales aplicables.</p>
              </Section>

              <Section title="6. Compartición de información con terceros">
                <p className="mb-3">LINK no venderá ni comercializará los datos personales de sus usuarios.</p>
                <p className="mb-3">La información podrá ser compartida con proveedores o terceros que presten servicios necesarios para nuestra operación, tales como servicios tecnológicos, alojamiento web, plataformas de comunicación, herramientas de analítica, servicios de marketing u otros proveedores relacionados.</p>
                <p className="mb-3">Cuando corresponda, estos terceros deberán tratar la información únicamente para las finalidades autorizadas y bajo condiciones adecuadas de confidencialidad y protección.</p>
                <p>También podremos proporcionar información cuando exista una obligación legal o un requerimiento válido de una autoridad competente.</p>
              </Section>

              <Section title="7. Cookies y tecnologías similares">
                <p className="mb-3">Nuestro sitio web puede utilizar cookies y tecnologías similares para garantizar su correcto funcionamiento, analizar el comportamiento de navegación, mejorar la experiencia del usuario y, cuando corresponda y exista la autorización necesaria, realizar acciones de medición o publicidad.</p>
                <p>Los usuarios podrán administrar o deshabilitar determinadas cookies desde la configuración de su navegador o mediante las herramientas de consentimiento disponibles en el sitio web.</p>
              </Section>

              <Section title="8. Derechos de los titulares">
                <p className="mb-3">Los titulares de los datos personales podrán ejercer los derechos reconocidos por la normativa ecuatoriana aplicable en materia de protección de datos personales, incluyendo, según corresponda, los derechos de acceso, rectificación y actualización, eliminación, oposición, suspensión del tratamiento y portabilidad, entre otros reconocidos legalmente.</p>
                <p className="mb-3">Para ejercer estos derechos, el titular podrá enviar una solicitud a: <a href="mailto:estamos@pasameunlink.com"><strong>estamos@pasameunlink.com</strong></a></p>
                <p>La solicitud deberá contener información suficiente para verificar la identidad del titular y determinar los datos respecto de los cuales desea ejercer sus derechos.</p>
              </Section>

              <Section title="9. Enlaces a sitios externos">
                <p className="mb-3">Nuestro sitio web puede contener enlaces hacia sitios web, redes sociales o plataformas administradas por terceros.</p>
                <p>LINK no controla las políticas de privacidad ni las prácticas de tratamiento de información de dichos sitios, por lo que recomendamos revisar sus respectivas políticas antes de proporcionar información personal.</p>
              </Section>

              <Section title="10. Datos proporcionados voluntariamente">
                <p className="mb-3">Al completar formularios, solicitar información, comunicarse con LINK o proporcionar datos personales mediante nuestros canales digitales, el usuario declara que la información proporcionada es verdadera, exacta y actualizada.</p>
                <p>Cuando el tratamiento requiera consentimiento, LINK implementará los mecanismos correspondientes para obtenerlo de manera adecuada.</p>
              </Section>

              <Section title="11. Modificaciones a esta política">
                <p className="mb-3">LINK podrá actualizar esta Política de Privacidad cuando sea necesario debido a cambios legales, tecnológicos, operativos o relacionados con nuestros servicios.</p>
                <p>La versión vigente estará disponible permanentemente en nuestro sitio web, indicando la fecha de su última actualización.</p>
              </Section>

              <Section title="12. Contacto">
                <p className="mb-2">Para consultas relacionadas con esta Política de Privacidad o con el tratamiento de datos personales, puedes comunicarte con nosotros a través de:</p>
                <ul className="space-y-0.5">
                  <li><strong>LINK</strong></li>
                  <li><strong>RUC:</strong> 1793146813001</li>
                  <li><strong>Domicilio:</strong> Cumbayá, Quito, Ecuador</li>
                  <li><strong>Correo electrónico:</strong> <a href="mailto:estamos@pasameunlink.com">estamos@pasameunlink.com</a></li>
                  <li><strong>Teléfono:</strong> 099 771 7151</li>
                </ul>
              </Section>

              <p className="mt-10 italic text-[#58677A]/85 border-l-4 border-[#ED6B24] pl-4 py-2 bg-[#ED6B24]/5 rounded-r">
                En <strong>LINK</strong>, cada conexión importa. Por eso cuidamos también la información que compartes con nosotros, con responsabilidad, transparencia y mucho <span className="text-[#ED6B24] font-semibold">corazón naranja</span>.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2
        className="text-lg sm:text-xl lg:text-2xl font-bold text-[#58677A] mb-3"
        style={{ fontFamily: 'Gotham, sans-serif' }}
      >
        {title}
      </h2>
      <div className="text-[#58677A]/90">{children}</div>
    </section>
  );
}
